/*
 * Velora - label zero-cost add-ons as free
 * -----------------------------------------------------------------
 * sections/velora-buy.liquid builds its add-on rows in inline JS and
 * always prints '+' + fmt(price). For a free add-on such as the Sleep
 * Well eBook that renders as "+$0.00", which reads like a broken price
 * rather than a freebie.
 *
 * This swaps the price label for "Included for free" whenever the
 * amount is zero. The row, its checkbox and its title are left alone,
 * so the add-on still works exactly as before. Paid add-ons keep their
 * normal "+$2.99" style label and are never touched.
 *
 * Keyed on the amount being zero rather than on a specific product, so
 * any future free add-on inherits the same treatment.
 *
 * This is a surgical patch applied from outside the section so the
 * 30KB buy-box file does not have to be rewritten. The tidier fix is
 * to handle the zero case inside buildAddons() in velora-buy.liquid.
 *
 * To remove: delete this file and its <script> tag in layout/theme.liquid.
 * -----------------------------------------------------------------
 */
(function () {
  'use strict';

  var FREE_LABEL = 'Included for free';

  // Matches "+$0.00", "$0.00", "+0,00" and similar zero amounts.
  var ZERO = /^[+\s]*[^0-9]*0(?:[.,]0+)?\s*$/;

  function relabel() {
    var nodes = document.querySelectorAll('[data-vaddons] .vmai-p');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var text = (el.textContent || '').trim();

      if (text && ZERO.test(text)) {
        el.textContent = FREE_LABEL;
        el.classList.add('vmai-p--free');
      }
    }
  }

  function injectStyles() {
    if (document.getElementById('velora-free-addon-styles')) return;

    var style = document.createElement('style');
    style.id = 'velora-free-addon-styles';
    // Inherits the theme's font. Only the casing and tracking are nudged
    // so the words sit comfortably where a short price used to.
    style.textContent =
      '[data-vaddons] .vmai-p--free{' +
      'white-space:nowrap;' +
      'font-size:12px;' +
      'letter-spacing:.02em;' +
      'text-transform:uppercase;' +
      '}';
    document.head.appendChild(style);
  }

  function start() {
    injectStyles();
    relabel();

    if (!window.MutationObserver) return;

    var wraps = document.querySelectorAll('[data-vaddons]');
    for (var i = 0; i < wraps.length; i++) {
      // buildAddons() replaces innerHTML wholesale, so re-run on any child
      // change. Our own edit re-fires this, but the second pass finds no
      // zero amounts left and the loop settles immediately.
      new MutationObserver(relabel).observe(wraps[i], {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
